import { render, staticRenderFns } from "./IndustryTrends.vue?vue&type=template&id=5bb3c536&scoped=true&"
import script from "./IndustryTrends.vue?vue&type=script&lang=js&"
export * from "./IndustryTrends.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTrends.vue?vue&type=style&index=0&id=5bb3c536&lang=less&scoped=true&"
import style1 from "./IndustryTrends.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb3c536",
  null
  
)

export default component.exports